/******Carousel******/
/*PAGE*/
export default function Carousel() {
  //Carousel slider animation Parameters
  window.onload = function () {
    var slides = document.getElementsByClassName("carousel-item"),
      addActive = function (slide) {
        slide.classList.add("active");
      },
      removeActive = function (slide) {
        slide.classList.remove("active");
      };
    addActive(slides[0]);

    setInterval(function () {
      for (var i = 0; i < slides.length; i++) {
        if (i + 1 == slides.length) {
          addActive(slides[0]);
          slides[0].style.zIndex = 100;
          setTimeout(removeActive, 350, slides[i]);
          break;
        }
        if (slides[i].classList.contains("active")) {
          slides[i].removeAttribute("style");
          setTimeout(removeActive, 350, slides[i]);
          addActive(slides[i + 1]);
          break;
        }
      }
    }, 5000);
  };

  /*DOM*/
  return (
    <div className="carousel intro" id="intro">
      <div className=" titleWrap2">
        <h1 className="numTitle2">UNANÎMES</h1>
      </div>

      <video id="background-video" autoPlay loop muted>
        <source src="./bckVid2.mp4" type="video/mp4" />
      </video>

      <div className="carousel-item">
        <div>
          <h3>Enseignement Numérique</h3>
        </div>
      </div>

      <div className="carousel-item">
        <div>
          <h3>Campus augmenté</h3>
        </div>
      </div>

      <div className="carousel-item">
        <div>
          <h3>Simplification administrative</h3>
        </div>
      </div>

      <div className="carousel-item">
        <div>
          <h3>Nouvelles approches pédagogiques</h3>
        </div>
      </div>

      <div className="carousel-item">
        <div>
          <h3>Simplification administrative</h3>
        </div>
      </div>
    </div>
  );
}
